module.exports = __webpack_public_path__ + "static/media/success-star.ddfbc50c.svg";